import styled from '@emotion/styled'

export const SearchLoadingStyled = styled('div')({
  fontSize: '1.8rem',
})
